import React from 'react';

import Button from './Button';

export default ({ onTryAgain }) =>
  <div style={{ textAlign: 'center', marginTop: '10px' }}>
    <img
      src="https://paddee.herokuapp.com/icons/ic_0_loading_error@3x.png"
      alt="Error icon"
      style={{ width: '100px' }}
    />
    <div style={{ padding: '10px 0 10px 0' }}>
      Unable to load. Please try again later.
    </div>
    <Button onClick={onTryAgain}>Try again</Button>
  </div>;



// WEBPACK FOOTER //
// ./src/components/ErrorBlock.js